<template>
  <section
    class="chat"
    :class="{ 'chat--dialog': inDialog, 'chat--mail': isMailTicket }"
    v-if="selectedTicket && 'id_ticket' in selectedTicket"
  >
    <div class="header-chat" :class="{ 'header-chat--mail': isMailTicket }">
      <div class="grid">
        <div class="col-9">
          <div class="grid">
            <div class="col-12 pl-4 id-number">
              # {{ selectedTicket.id_ticket }} - {{ selectedTicket.area }}
              <span v-if="isMailTicket" class="mail-chip">EMAIL</span>
            </div>
            <div class="col-12 pl-4 flex align-items-center flex-wrap gap-1">
              <div class="title mr-2">
                {{ selectedTicket.title }}
              </div>
              <Button
                v-if="
                  selectedTicket &&
                  (
                    (
                      selectedTicket.id_entity &&
                      ['cliente', 'client', 'rappresentante'].includes(
                        (selectedTicket.entity_type || '').toLowerCase()
                      )
                    ) ||
                    (
                      selectedTicket.id_assigned_user &&
                      ['cliente', 'client', 'rappresentante'].includes(
                        (selectedTicket.assigned_user_type || '').toLowerCase()
                      )
                    )
                  )
                "
                :label="
                  (selectedTicket.entity_type || selectedTicket.assigned_user_type || '')
                    .toLowerCase()
                    .includes('rapp')
                    ? 'Scheda Rappresentante'
                    : 'Scheda Cliente'
                "
                icon="pi pi-external-link"
                class="p-button-text p-button-sm"
                @click="openLinkEntity(selectedTicket)"
              />
              <Button
                v-if="canOpenIncall(selectedTicket)"
                label="Incall"
                icon="pi pi-phone"
                class="p-button-outlined p-button-sm ticket-incall-btn"
                @click="openIncall(selectedTicket)"
              />
            </div>
            <div v-if="hasCallTransferInfo(selectedTicket)" class="col-12 pl-4">
              <span :class="getCallTransferBadgeClass(selectedTicket)">
                <i class="pi pi-phone mr-1"></i>
                {{ getTicketCallTransferLabel(selectedTicket) }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="grid pr-4">
            <div class="col-12 flex align-items-center justify-content-end">
              <div class="circle-status" :style="`background-color:${selectedTicket.color}`"></div>
              <div
                v-if="!isMailTicket"
                class="clickable status"
                @click="statusMenu.toggle($event)"
              >{{ selectedTicket.status }}</div>
              <div v-else class="status">{{ selectedTicket.status }}</div>
              <Menu v-if="!isMailTicket" ref="statusMenu" :popup="true" :model="status"></Menu>
            </div>
            <div class="col-12 flex align-items-center justify-content-left" v-if="shouldShowBloccaSospensione && !isMailTicket">
              <Button
                label="CHECK SOSPENSIONE"
                icon="pi pi-search"
                class="p-button-danger p-button-sm block-sospensione-btn"
                :loading="isCheckingContestazione"
                @click="openCheckSospensioneDialog"
              />
            </div>
            <div class="col-12 history flex align-items-center justify-content-end">
              <div class="mt-1"
                v-if="selectedTicket && 'history_status' in selectedTicket && selectedTicket.history_status.length > 1">
                <small>{{ selectedTicket.history_status.slice(-1)[0].name }} <i @click="dialogHistoryStatus = true"
                    class="text-primary pi pi-info-circle clickable"></i></small>
              </div>
            </div>
            <div
              v-if="!isMailTicket"
              class="col-12 assign clickable flex align-items-center justify-content-end"
            >
              <div @click="dialogAssignment = true">assegna</div>
              <small v-if="selectedTicket.history_assignment.length > 0"><i
                  @click="dialogHistoryAssignment = true"
                  class="text-primary pi pi-info-circle clickable"></i></small>
            </div>
            <div
              v-else-if="selectedTicket.history_assignment.length > 0"
              class="col-12 assign flex align-items-center justify-content-end"
            >
              <small><i
                  @click="dialogHistoryAssignment = true"
                  class="text-primary pi pi-info-circle clickable"></i></small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="messages-chat">
      <Divider align="center">
        {{ isMailTicket ? 'conversazione email' : 'inizio chat' }}
      </Divider>

      <!-- Ticket MAIL: thread email intero (stile client mail), non bolle chat -->
      <div v-if="isMailTicket" class="mail-ticket-board">
        <div v-if="mailThreadLoading" class="mail-thread-loading">
          Caricamento conversazione email…
        </div>
        <TicketMailThread v-else-if="mailThread.length" :mails="mailThread" />
        <div v-else class="mail-thread-empty">
          Nessuna email collegata a questo ticket.
        </div>

        <div
          v-for="message in nonMailMessages"
          :key="message.id_ticket_message"
          :id="`message_${message.id_ticket_message}`"
          :class="!message.read ? 'message-not-read' : 'message-read'"
        >
          <div class="message">
            <div class="badge-name" v-if="message.id_user != currentUser.user[0].id"
              :style="`background-color:${randomColorFromString(message.sender)}`">
              {{ getInitialOfName(message.sender) }}
            </div>
            <div :class="message.id_user == currentUser.user[0].id ? 'response' : ''">
              <p class="text" v-html="message.content"></p>
            </div>
          </div>
          <p :class="['time', message.id_user == currentUser.user[0].id ? 'response-time' : '']">
            {{ moment(message.datetime).format('HH:mm') }} · {{ message.sender }}
          </p>
        </div>
      </div>

      <div v-else>
        <div v-for="(messages, date) in selectedTicket.messages" :key="date">
          <Divider align="center" class="sticky-date">
            {{ moment(date).isValid() ? moment(date).locale('it').format("DD MMM YYYY").toUpperCase() : '/' }}
          </Divider>
          <div v-for="message in messages" :key="message.id_ticket_message"
            :id="`message_${message.id_ticket_message}`"
            :class="!message.read ? 'message-not-read' : 'message-read'">
            <div class="message">
              <div class="badge-name" v-if="message.id_user != currentUser.user[0].id"
                :style="`background-color:${randomColorFromString(message.sender)}`">
                {{ getInitialOfName(message.sender) }}
              </div>
              <div :class="message.id_user == currentUser.user[0].id ? 'response' : ''">
                <div
                  v-if="hasCallTransferInfo(message)"
                  class="ticket-message-transfer"
                  :class="getCallTransferBadgeClass(message)"
                >
                  <i class="pi pi-phone"></i>
                  {{ getTicketCallTransferLabel(message) }}
                </div>
                <p class="text" v-html="message.content"></p>
              </div>
            </div>
            <div v-if="(message.attachments || []).length > 0" class="attachments">
              <div v-for="attachment in message.attachments" :key="attachment.code || attachment.mail_attachment_id || attachment.name" class="attachment mb-2">
                <div class="grid">
                  <div class="col-10"><i class="pi pi-file mr-2"></i> {{ attachment.name }}</div>
                  <div class="col-2 flex justify-content-end">
                    <i class="pi pi-eye mr-3" @click="openAttachment(attachment)"></i>
                    <i class="pi pi-download mr-1" @click="downloadAttachment(attachment)"></i>
                  </div>
                </div>
              </div>
            </div>
            <p :class="['time', message.id_user == currentUser.user[0].id ? 'response-time' : '']">
              {{ moment(message.datetime).format('HH:mm') }} · {{ message.sender }}
            </p>
          </div>
        </div>
      </div>
      <div id="scroll-last"></div>
    </div>

    <div v-if="!isMailTicket" class="footer-chat">
      <div class="footer-chat-inner">
        <div class="footer-chat-transfer">
          <div class="footer-chat-transfer-item">
            <label for="replyCallTransferSuccess">
              <i class="pi pi-phone"></i>
              Trasferimento
            </label>
            <Dropdown
              inputId="replyCallTransferSuccess"
              v-model="replyCallTransferSuccess"
              :options="callTransferOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Non specificato"
              class="footer-chat-dropdown"
              @change="onReplyCallTransferSuccessChange"
            />
          </div>
          <div
            v-if="requiresCallTransferArea(replyCallTransferSuccess)"
            class="footer-chat-transfer-item"
          >
            <label for="replyCallTransferArea">
              <i class="pi pi-arrow-right-arrow-left"></i>
              Area
            </label>
            <Dropdown
              inputId="replyCallTransferArea"
              v-model="replyCallTransferAreaId"
              :options="ticketAreas"
              optionLabel="area"
              optionValue="id_ticket_area"
              :filter="true"
              placeholder="Seleziona area..."
              class="footer-chat-dropdown"
            />
          </div>
        </div>

        <div class="footer-chat-compose">
          <div class="footer-chat-attach">
            <button
              type="button"
              class="attach-btn"
              aria-label="Allega file"
              @click="openFilePicker"
            >
              <i class="pi pi-paperclip p-text-secondary"></i>
              <span
                v-if="filesToUpload.length > 0"
                class="badge-file p-badge p-component p-badge-primary p-badge-no-gutter"
              >{{ filesToUpload.length }}</span>
            </button>
            <input
              id="upload"
              ref="fileInput"
              :key="keyReset"
              type="file"
              class="attach-input-hidden"
              :accept="`${Object.values(allowedType).join(', ')}`"
              multiple
              @change="handleFileUpload($event)"
            />
          </div>
          <div class="footer-chat-input">
            <Textarea
              v-model="newMessage"
              class="write-message w-full"
              placeholder="Scrivi qui ..."
              :autoResize="true"
              rows="1"
            />
          </div>
          <div class="footer-chat-send">
            <Button
              @click="sendMessage"
              :loading="isSending"
              class="p-button-rounded p-3 ask-send"
              aria-label="Invia messaggio"
            >
              <img src="../../assets/img/A.png" height="15" />
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="footer-chat footer-chat--readonly">
      <i class="pi pi-eye"></i>
      Solo visualizzazione — non è possibile rispondere ai ticket email
    </div>
  </section>
</template>

<script>
import { computed, inject, ref } from 'vue'
import Button from 'primevue/button'
import Menu from 'primevue/menu'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import Textarea from 'primevue/textarea'
import TicketMailThread from '@/components/tickets/TicketMailThread.vue'

export default {
  name: 'TicketChatPanel',
  components: {
    Button,
    Menu,
    Divider,
    Dropdown,
    Textarea,
    TicketMailThread,
  },
  props: {
    inDialog: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const statusMenu = ref(null)
    const fileInput = ref(null)
    const ticketChat = inject('ticketChat')

    const openFilePicker = () => {
      fileInput.value?.click()
    }

    const mailThread = computed(() => {
      const thread = ticketChat?.selectedTicket?.value?.mail_thread
      return Array.isArray(thread) ? thread : []
    })

    const mailThreadLoading = computed(() => {
      return Boolean(ticketChat?.selectedTicket?.value?.mail_thread_loading)
    })

    const isMailTicket = computed(() => {
      const ticket = ticketChat?.selectedTicket?.value
      if (!ticket) return false
      if (ticket.is_mail === true || ticket.is_mail === 1 || ticket.is_mail === '1') return true
      if (mailThread.value.length > 0) return true
      const area = String(ticket.area || ticket.areaCode || '').toLowerCase()
      return area === 'mail' || area.includes('mail')
    })

    const nonMailMessages = computed(() => {
      const ticket = ticketChat?.selectedTicket?.value
      if (!ticket?.messages) return []
      const flat = []
      Object.values(ticket.messages).forEach((group) => {
        const list = group || []
        list.forEach((message) => {
          if (message?.mail || message?.is_mail) return
          const content = String(message?.content || '')
          if (content.includes('Mail convertita in ticket')) return
          flat.push(message)
        })
      })
      return flat
    })

    return {
      statusMenu,
      fileInput,
      openFilePicker,
      isMailTicket,
      mailThread,
      mailThreadLoading,
      nonMailMessages,
      ...ticketChat,
    }
  },
}
</script>

<style scoped>
.chat {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh - 12em);
}

.chat--dialog {
  height: 58vh;
  max-height: 640px;
  min-height: 420px;
}

.header-chat {
  background-color: #fff;
  height: 90px;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  position: sticky;
  top: 0;
  z-index: 2;
}

.header-chat--mail {
  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 70%);
  border-bottom: 1px solid #bfdbfe;
  box-shadow: none;
}

.chat--mail .messages-chat {
  background: #f8fbff;
}

.mail-chip {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 7px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #1d4ed8;
  background: #dbeafe;
  vertical-align: middle;
}

.mail-ticket-board {
  padding-bottom: 8px;
}

.mail-thread-loading,
.mail-thread-empty {
  margin: 12px 16px;
  padding: 18px 16px;
  border: 1px dashed #bfdbfe;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

.chat .header-chat .id-number {
  text-transform: uppercase;
  color: #b5b5b5;
}

.chat .header-chat .title {
  font-size: calc(0.4vw + 0.5vh + 0.1vmin);
  font-weight: bold;
}

.chat .header-chat .status {
  color: var(--primary-color);
}

.chat .header-chat .history {
  margin-top: -14px;
}

.chat .header-chat .assign {
  font-size: 12px;
  color: var(--primary-color);
}

.chat .header-chat .circle-status {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 5px;
}

.chat .header-chat .status .text {
  font-size: 12px;
}

.chat .messages-chat {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 25px;
}

.chat .messages-chat .message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.chat .messages-chat .message .badge-name {
  display: block;
  width: 45px;
  min-width: 45px;
  height: 45px;
  border: 1px solid rgba(51, 51, 51, 0.13);
  border-radius: 50px;
  font-size: 16px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat .messages-chat .text {
  margin: 0 20px;
  background-color: #f6f6f6;
  padding: 15px;
  border-radius: 12px;
  white-space: pre-wrap;
}

.chat .messages-chat .ticket-mail-view {
  margin: 0 20px;
  max-width: min(720px, 92%);
  flex: 1;
}

.chat .messages-chat .sticky-date {
  position: sticky;
  top: 12px;
}

.time {
  font-size: 10px;
  color: lightgrey;
  margin-bottom: 10px;
  margin-left: 85px;
}

.response-time {
  display: flex;
  justify-content: right;
  margin-right: 40px !important;
}

.response {
  float: right;
  margin-right: 0px !important;
  margin-left: auto;
}

.response .text {
  background-color: #e3effd !important;
}

.footer-chat {
  width: 100%;
  flex-shrink: 0;
  background-color: #f4f6f8;
  border-top: 1px solid #e3e7ec;
  padding: 0.7rem 1rem 0.85rem;
}

.footer-chat--readonly {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0.9rem 1rem;
  color: #64748b;
  font-size: 13px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.footer-chat--readonly .pi {
  color: #94a3b8;
}

.footer-chat-inner {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  width: 100%;
}

.footer-chat-transfer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.85rem;
  padding: 0.5rem 0.65rem;
  background: #fff;
  border: 1px solid #e5e9ef;
  border-radius: 10px;
}

.footer-chat-transfer-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1 220px;
  min-width: 0;
}

.footer-chat-transfer-item label {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
}

.footer-chat-compose {
  display: flex;
  align-items: flex-end;
  gap: 0.55rem;
  padding: 0.45rem 0.55rem;
  background: #fff;
  border: 1px solid #e5e9ef;
  border-radius: 12px;
}

.footer-chat-attach {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
}

.attach-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.attach-btn .pi-paperclip {
  font-size: 1.35rem;
}

.attach-btn .badge-file {
  position: absolute;
  top: -2px;
  right: -10px;
}

.ticket-incall-btn {
  margin-left: 0.35rem;
}

.attach-input-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  pointer-events: none;
}

.footer-chat-input {
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.footer-chat-send {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.write-message {
  border: none !important;
  width: 100%;
  min-height: 42px;
  max-height: 120px;
  margin: 0;
  padding: 0.45rem 0.2rem;
  outline: none;
  background: transparent;
  box-shadow: none !important;
  resize: none;
}

.clickable {
  cursor: pointer;
}

:deep(.box-unread) {
  display: flex;
  justify-content: center;
  margin: 20px 10px;
  background: white;
  color: #d5d5d5;
  padding: 5px;
}

.block-sospensione-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
}

.call-transfer-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
}

.call-transfer-badge--success {
  color: #166534;
  background: #ecfdf3;
}

.call-transfer-badge--failed {
  color: #b91c1c;
  background: #fef2f2;
}

.ticket-message-transfer {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.45rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}

.attachments .attachment {
  cursor: pointer;
  background-color: #e3e3e3;
  padding: 12px;
  border-radius: 12px;
}

.attachments div[class^='col'] {
  display: flex;
  align-items: center;
}
</style>
